import "./ServiceCard.scss";

interface ServiceCardProps {
  number: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  tags: string[];
}

const ServiceCard = ({
  number,
  icon,
  title,
  description,
  tags,
}: ServiceCardProps) => {
  return (
    <div className="serviceCard fi" data-n={number}>
<div className="serviceIcon">{icon}</div>
      <div className="serviceTitle">{title}</div>
      <p className="serviceDesc">{description}</p>
      <div className="serviceTags">
        {tags.map((tag) => (
          <span key={tag} className="serviceTag">
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ServiceCard;
